import { all, put, takeEvery } from 'redux-saga/effects'
import _ from 'lodash'

import config from '../../../../../../../../../config'

import { TABS_PRIORITY } from './constants'
import { BLOCK_DATA_LOADED } from '../../../../../../../components/Workspace/components/HocBlock/constants'
import { blockDataTransformed } from '../../../../../../../components/Workspace/components/HocBlock/actions'

function* onDataLoaded(_action) {
    const blockKey = _.get(_action, 'data.blockKey', null)
    if (blockKey !== config.modules.report.blocks.regInfo.key) return null

    const module = _.get(_action, 'data.module', null)
    const id = _.get(_action, 'data.id', null)
    if (!module || !id || !blockKey) return null

    const data = _.get(_action, 'data.data', null)

    // Transformation start
    const transformedData = _.reduce(
        TABS_PRIORITY,
        (acc, tabId, tabIndex) => {
            const tabData = _.get(data, tabId, null)
            const isDisabled = _.isEmpty(_.get(tabData, '_table', []))

            return {
                ...acc,
                [tabId]: isDisabled,
                defaultIndex: !isDisabled && acc.defaultIndex === -1 ? tabIndex : acc.defaultIndex,
                noData: isDisabled && acc.noData,
            }
        },
        { defaultIndex: -1, noData: true }
    )
    // Transformation end

    yield put(blockDataTransformed(module, id, blockKey, transformedData))

    return null
}

export default function* blockTransformSaga() {
    yield all([takeEvery(BLOCK_DATA_LOADED, onDataLoaded)])
}
